// extracted by mini-css-extract-plugin
export default {"form":"ChangePassword_form__iYnRP","form__container":"ChangePassword_form__container__dv1A9","form__button__container":"ChangePassword_form__button__container__d35+e"};